export default __webpack_public_path__ + "static/media/EnikoFodor1.d078cd3a.png";